'use strict';

import * as angular from 'angular';
var app = angular.module('noc.base', []);

app.service('ConfigService', require('./ConfigService'));
app.factory('ErrorLogger', require('./errorLogger'));
app.controller('ErrorPageController', require('./errorPageController'));
app.factory('ProjectCookieFactory', require('./projectCookieFactory'));
app.factory('ProjectService', require('./ProjectService'));
app.factory('RedirectService', require('./redirectService'));
app.factory('TrainCacheService', require('./TrainCacheService'));
app.factory('TrainMaintainerService', require('./TrainMaintainerService'));
app.factory('TrainTypeService', require('./TrainTypeService'));
app.factory('UrlRoutingFactory', require('./urlRoutingFactory'));

export default app;